import { useCallback, useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

import DropdownMenu from './DropdownMenu';
import messages from './Navigation.messages';
import styles from './Navigation.module.css';
import IwMedia from '../../iwMedia/IwMedia';

const MenuAction = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { key: locationKey } = useLocation();
    const menuRef = useRef<HTMLDivElement>(null);

    const toggleMenu = () => setIsOpen(!isOpen);

    const handleClick = useCallback(
        (e: MouseEvent) => {
            if (
                menuRef.current !== null &&
                e.target !== null &&
                !menuRef.current.contains(e.target as Node)
            ) {
                setIsOpen(false);
            }
        },
        [menuRef, setIsOpen]
    );
    useEffect(() => {
        document.addEventListener('click', handleClick);
        return () => document.removeEventListener('click', handleClick);
    }, [handleClick]);

    useEffect(() => {
        setIsOpen(false);
    }, [locationKey]);

    return (
        <>
            <div className={styles.menuContainer} ref={menuRef}>
                <button
                    data-testid="dropdown-menu-toggle"
                    className={styles.rightAction}
                    onClick={toggleMenu}
                >
                    <FormattedMessage {...messages.menu} />{' '}
                    <div
                        className={classNames(
                            styles.navIcon,
                            isOpen && styles.closeIcon
                        )}
                    >
                        <span className={styles.menuIconLine} />
                        <span className={styles.menuIconLine} />
                        <span className={styles.menuIconLine} />
                        <span
                            className={classNames(
                                styles.menuIconLine,
                                styles.animatedLine
                            )}
                        />
                        <span
                            className={classNames(
                                styles.menuIconLine,
                                styles.animatedLine
                            )}
                        />
                    </div>
                </button>
                <DropdownMenu isOpen={isOpen} setIsOpen={setIsOpen} />
            </div>
            <IwMedia to="medium">
                <div
                    data-testid="mobile-nav-underlay"
                    className={classNames(
                        styles.mobileMenuUnderlay,
                        !isOpen && styles.hideUnderlay
                    )}
                />
            </IwMedia>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default MenuAction;
